export const colors = {
    background: '#f8f7f6',
    button: 'rgba(99, 105, 81, 0.2)',
    illustration: 'rgba(99, 105, 81, 0.4)',
    photo: 'rgba(99, 105, 81, 0.6)',
    title: '#636951',
    latte: '#caa58e',
    grey: '#BDBEB5',
    black: '#2d2d2d',
}